import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Header, Sidebar } from '../Layout';
import { Link, useHistory } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { Loading } from '../../shared';
import { getEmailTemplates, destryoTemplate, 
    // updateEmailTemplateStatus 
} from '../../../actions/emailTemplateActions';
import moment from 'moment';
import ViewModal from './ViewModal';
const EmailTemplates = (props) => {
    const dispatch = useDispatch()
    const history = useHistory();

    const { loading, emailtemplates } = useSelector(state => state.emailtemplateReducers)
    const [deleteProfileModal, setDeleteProfileModal] = useState(false)
    // const [editData, setEditData] = useState()
    const [editMode, setEditMode] = useState(false)
    const [viewMode, setViewMode] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(false);

    // const { user } = useSelector(state => state.auth)
    const [templateId, setTemplateId] = useState()
    // const currentUser = user;
    // const [currentPage, setCurrentPage] = useState(1)
    useEffect(() => {
        dispatch(getEmailTemplates())
    }, [dispatch])


    // const deleteProfileModalShow = templateId => {
    //     setTemplateId(templateId)
    //     setDeleteProfileModal(true)
    // }

    const deleteProfileModalClose = () => {
        setDeleteProfileModal(false)
        setTemplateId()
    }

    const handleDeleteProfileSubmit = async () => {
        await dispatch(destryoTemplate(templateId))
        setDeleteProfileModal(false)
        await dispatch(getEmailTemplates())
        setTemplateId()
    }
    if (loading) {
        return (
            <Loading />
        );
    }

    const redirectToEditPage = templateId => {
        return history.push(`/admin/update-email-template?type=${templateId}`)
    }
    const openPreviewModal = (template) => {
        setViewMode(true);
        setSelectedRowData(template);
    }
    const handlePreviewClose = () => {
		setViewMode(false);
		setSelectedRowData(false);
	};
    const hideEditModal = () => {
        setEditMode(false)
        setTemplateId()
    }
    // const updateTemplateStatus =async (event, id)=>{
    //     const templateData={
    //         id: id,
    //         status: event.target.checked
    //     }
    //    await dispatch(updateEmailTemplateStatus(templateData));
    //    await dispatch(getEmailTemplates())
    // }
   
    return (
        <>
            <Header />
            <Sidebar />
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Email Template Managment</h2>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Email Template Managment</li>
                            </ul>
                            <Link to="/admin/create-email-template" className="btn btn-sm button" title="">Create New</Link>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix">
                        <div className="col-lg-12">
                            <div className="card">
                                {/* <div className="header">
                                    <h2>Email Managment </h2>
                                </div> */}
                                <div className="body">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover js-basic-example dataTable table-custom">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Subject</th>
                                                    <th>Email Type</th>
                                                    {/* <th>Status</th> */}
                                                    <th>Created At</th>
                                                    <th>Updated At</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emailtemplates && emailtemplates?.map((template, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{template?.subject}</td>
                                                        <td>{template?.email_type}</td>
                                                        {/* <td>
                                                            <div className="custom-control custom-switch">
                                                                <input type="checkbox" className="custom-control-input" id={`box-${index}`} checked={template?.status ? true : false } onChange={(event)=>{updateTemplateStatus(event, template.id)}}/>
                                                                <label className="custom-control-label" htmlFor={`box-${index}`}></label>
                                                            </div>
                                                        </td> */}
                                                        <td>{moment(template?.createdAt).format('DD/MM/YYYY')}</td>
                                                        <td>{moment(template?.updatedAt).format('DD/MM/YYYY')}</td>
                                                        <td>
                                                            <Button variant="outlined" size="small" color="dark" onClick={() => openPreviewModal(template)}><i className="fa fa-eye" aria-hidden="true"></i></Button>
                                                            <Button variant="outlined" size="small" color="dark" onClick={() => redirectToEditPage(template.email_type)}><i className='fa fa-edit'></i></Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {!emailtemplates ? <div className='text-center font-weight-bold'>No Records</div> : null}
                                    </div>
                                </div>
                                <Modal show={deleteProfileModal} onHide={deleteProfileModalClose} className="modal fade modal-bx-info" id="exampleModalLong" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
                                    <div className="modal-dialog  m-0" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title text-danger">Delete Email Template From Server</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={deleteProfileModalClose}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                Are you sure to delete?
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleDeleteProfileSubmit}>Confirm</button>

                                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={deleteProfileModalClose}>Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </Modal>

                                {/* Modal for editing tod */}
                                <Modal
                                    show={editMode} onHide={hideEditModal}
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title id="contained-modal-title">Edit Your Subadmin</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="col-md-12">
                                            {/* {editMode  &&
                                        <EditForm data={editData} hideEditModal={hideEditModal} />
                                    } */}

                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button onClick={hideEditModal}>Close</Button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ViewModal
                open={viewMode}
                close={handlePreviewClose}
                data={selectedRowData}
            />
        </>
    )
}

export default EmailTemplates;